import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from "@angular/core";
import {Cohort} from "../../model/cohort";
import {Criterion} from "../../model/criterion";
import {Drug} from "../../model/drug";
import {Observable} from "rxjs";
import {DragulaService} from "ng2-dragula";

@Component({
  selector: 'gen-cohort-editor',
  templateUrl: './cohort-editor.component.html',
  styleUrls: ['./cohort-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CohortEditorComponent implements OnInit, OnDestroy{
  public cohortInfoFormName: string;
  public isValid: boolean;
  public form;

  @Input() cohort: Cohort;
  @Input() events: Observable<void>;
  @Output() cloneMe = new EventEmitter<Cohort>();
  @Output() deleteMe = new EventEmitter<Cohort>();
  @Output() closeMe = new EventEmitter();

  // initialize the base number (as current time milliseconds) for generating unique object's ID
  private static baseIdCounter: number = performance.now();
  public listName: string = undefined;

  constructor(private dragulaService: DragulaService) {
    this.cohortInfoFormName = "CURATION-TRIAL-COHORT-INFO";
  }

  ngOnInit() {
    this.cohortInfoFormName = "CURATION-TRIAL-COHORT-INFO";

    // set a unique list's name to ensure no duplications in dragulaService's bag list
    if (!this.listName) {
      this.listName = 'criterion_items_' + CohortEditorComponent.baseIdCounter++;
    }

    // to use the dragulaService, it is required to call the setOptions method, specifying the container and providing
    // an object literal with your desired options
    if (! this.dragulaService.find(this.listName)) { // need to search first that name is not already added to avoid an error
      this.dragulaService.setOptions(this.listName, {
        moves: (element, container, handle) => {
          return handle.className.startsWith('fa fa-bars') && handle.parentElement.className.startsWith('criterion');
        }
      });
    }
  }

  ngOnDestroy(): void {
    // remove the current list from the dragulaService's bag list
    if (this.dragulaService.find(this.listName)) { // need to search first that name exists to avoid an error
      this.dragulaService.destroy(this.listName);
    }
  }

  isEmpty(block: Criterion): boolean {
    return !block || !block.conditions || block.conditions.length == 0;
  }

  addBlock() {
    this.cohort.criteria.push(new Criterion("any"));
  }

  duplicateCriterion(criterion: Criterion) {
    let k = this.cohort.criteria.indexOf(criterion);
    let newCriterion = JSON.parse(JSON.stringify(criterion));
    this.cohort.criteria.splice(k, 0, newCriterion);
  }

  deleteCriterion(criterion: Criterion) {
    this.cohort.criteria = this.cohort.criteria.filter(x => x != criterion);
  }

  onCloneMe() {
    this.cloneMe.emit(this.cohort);
  }

  onDeleteMe() {
    this.deleteMe.emit(this.cohort);
  }

  onCloseMe() {
    this.closeMe.emit();
  }

  validationEvent(valid) {
    this.isValid = valid;
  }

  formChanged(form) {
    this.cohort.info.status = form.status;
    this.cohort.info.drugs = [];
    for (let data of form.drugs)
    {
      let drug = new Drug();
      drug.id = data['id'];
      drug.CommonName = data['CommonName'];
      this.cohort.info.drugs.push(drug);
    }
  }

}
